const BASE_FONT = 18;

/**
 * Converts pixels to their REM equivalent at a given abse
 * @param px The size in Pixels to convert
 * @param base The base to scale the REM relative to
 * @returns {string} an REM string
 */
export function pxToRem(px: number) {
  return `${px / BASE_FONT}rem`;
}
